import type {FC} from 'react';
import {routes} from '../../../config/constants';
import {CommonLink} from '../../../shared/components/CommonLink';

type Props = {
  linkClassName: string;
  mailAuthLink: string;
};

export const RegisterBodyLegacy: FC<Props> = ({
  linkClassName,
  mailAuthLink,
}) => {
  return (
    <>
      <p className="mb-12 bg-background-1 px-8 py-4 text-md font-bold leading text-black-1">
        1.会員登録
      </p>
      <div id="a1" className="mt-16">
        <h3>
          <span>Q.</span>会員登録をしたい
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          以下より登録手続きを行なってください。
        </p>
        <p>
          ◆
          <CommonLink
            href={mailAuthLink}
            target="_blank"
            className={linkClassName}
          >
            国内の大学に在籍されている方はこちら
          </CommonLink>
        </p>
        <p>
          ◆海外の大学に在籍されている方
          <br />
          大学から発行されたメールアドレスの末尾に&#8221;.edu&#8221;、&#8221;.ac.uk&#8221;または&#8221;.ubc.ca&#8221;がつく方は、
          <CommonLink
            href={mailAuthLink}
            target="_blank"
            className={linkClassName}
          >
            新規会員登録フォーム
          </CommonLink>
          から登録手続きを行って下さい。上記以外の方は、
          <CommonLink
            href={routes.INQUIRY_FOREIGN_UNIV}
            target="_blank"
            className={linkClassName}
          >
            海外大生用の登録フォーム
          </CommonLink>
          より新規登録申込みをお願いします。
        </p>
      </div>
      <div id="a2" className="mt-16">
        <h3>
          <span>Q.</span>
          会員登録したいが大学発行のメールアドレスを持っていない
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          お手数ですが、一度大学にお問い合わせいただき、学生にメールアドレスを発行していないかご確認ください。
        </p>
        <p>
          もし大学発行のメールアドレスが存在しない場合は
          <CommonLink
            href={routes.STUDENT_CARD}
            target="_blank"
            className={linkClassName}
          >
            こちら
          </CommonLink>
          から、学生証画像による会員登録を行えます。
        </p>
        <p>
          ※画像審査には通常一週間ほどお時間を頂戴いたします。また、会員登録が正常に完了しない可能性がございますため、学生証画像の審査中の大学アドレスによる会員登録はご遠慮ください。
        </p>
        <p>
          学生証に関する受付完了メールが届かない場合、または一週間以上経過しても審査結果が届かない場合は、
          <CommonLink
            href={routes.INQUIRY}
            target="_blank"
            className={linkClassName}
          >
            こちら
          </CommonLink>
          から件名「学生証審査について」を選択し、お困りの内容をご連絡ください。
        </p>
      </div>

      <div id="a3" className="mt-16">
        <h3>
          <span>Q.</span>
          新規会員登録画面で、大学発行のメールアドレスを入力したが、「そのメールアドレスはすでに登録されています」と表示される
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          入力したメールアドレスは、既に登録が完了しております。
        </p>
        <p>
          パスワードを忘れてしまった場合は
          <CommonLink href="#b1" className={linkClassName}>
            パスワードを忘れた・変更したい
          </CommonLink>
          をご覧ください。
        </p>
      </div>

      <div id="a4" className="mt-16">
        <h3>
          <span>Q.</span>
          大学メールアドレスを入力したが、本登録用URLが記載されたメールが届かない
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          会員登録時の受信確認メールのご確認
        </p>
        <p>
          (1) 入力したメールアドレスに誤りがないかどうかのご確認
          <br />
          誤りがある場合、正しいメールアドレスで再度登録を行なってください。
        </p>
        <p>
          【よくある間違い】
          <br />
          -ピリオドがカンマになっている
          <br />
          -全角文字が含まれている
        </p>
        <p>
          (2) メールフィルター誤作動のご確認
          <br />
          返信メールがフィルターに弾かれ、「迷惑メールフォルダ」などに入ってしまっている可能性がございます。それらのフィルターが誤作動していないかご確認ください。
          <br />
          <br />
          尚、Office365などのサーバーでは、メールを「ブロックまたは許可する」というリストの編集をすることができます。以下のメールアドレスを許可/拒否の受信許可にご登録いただくことでメールの受信が可能になることがあります。
          <strong>
            <br />
            info@gaishishukatsu.com
          </strong>
        </p>
        <p>
          (3) 転送先受信設定のご確認
          <br />
          大学のメールアドレスに届いたメールをスマートフォンなどに転送して確認されている場合、スマートフォン側の迷惑メールの設定により転送先のサーバーでメールがブロックされてしまっていることがあります。
          <br />
          <br />
          ブロックを防止するためには、迷惑メールフィルターの設定画面より、
          <br />
          「救済リスト」もしくは「受信リスト」に以下メールアドレスのご登録をお願いいたします。
          <strong>
            <br />
            info@gaishishukatsu.com
          </strong>
        </p>
        <p>
          (4) 他メールソフト設定のご確認
          <br />
          他のメールソフトで大学のメールアドレスに届いたメールを確認されている場合、メールを「サーバーに残さない」設定にしていると、一度確認されたメールが削除されてしまいます。「サーバーに残す」設定になっているかご確認ください。
          <br />
        </p>
        <p>
          (5) お使いのメールボックスの容量のご確認
          <br />
          メールボックスの容量を増やすか、不要データを削除した後、再度登録を行なってください。
        </p>
        <p>
          (6) 学外からのメールが届かない設定になっていないかどうかのご確認
          <br />
          一部の大学では、大学ドメイン以外からの受信ができないメールアドレスがある場合がございます。大学のメール利用ガイドをご確認ください。
        </p>
      </div>

      <div id="a5" className="mt-16">
        <h3>
          <span>Q.</span>
          いつも使うメールアドレスの認証をしたいがログインできない
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          大変お手数ですが、ご登録をいただいたPCもしくはスマートフォンから大学メールアドレスにて
          ログインし、メールに記載のURLより認証を行ってください。
        </p>
      </div>

      <div id="a6" className="mt-16">
        <h3>
          <span>Q.</span>既卒だが会員登録をしたい
        </h3>
        <p>
          <span className="text-notification-1">A.</span>
          申し訳ございませんが、当サイトは大学・大学院に在籍している方の登録に限定しております。ご了承ください。
        </p>
      </div>
    </>
  );
};
